import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/';
import '@ifeng-fe/container_content/common/client/commoncss/resetMobile.css';
import './app.css';

/* eslint-disable no-undef */
ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
